import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
@Component({
  standalone: true,
  imports: [OptimUiSharedModule, CommonModule],
  selector: 'app-sidebar-minimizer',
  template: `
    <div class="sidebar-minimizer">
      <button class="minimizer-btn" title="Toggle minimize sidebar">
        <i class="fa" [class.fa-angle-left]="!minimized" [class.fa-angle-right]="minimized"></i>
      </button>
    </div>
  `,
  styles: [`
    .sidebar-minimizer {
      padding: 1rem 0.5rem;
      text-align: center;
      border-top: 1px solid rgba(255, 255, 255, 0.1);

      .minimizer-btn {
        background: none;
        border: none;
        color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
        font-size: 1.25rem;
        padding: 0.5rem;
        transition: all 0.3s ease;

        &:hover {
          color: white;
          transform: scale(1.1);
        }
      }
    }
  `]
})
export class SidebarMinimizerComponent {
  @Input() minimized: boolean = false
}
